module.exports = __webpack_public_path__ + "static/img/hungry_pink.1a6495de.png";